module.exports = __webpack_public_path__ + "h5-static/img/point_detail.b68d5602.png";